import { mapGroupBy } from '@plato/shared-util/map';
import { parseISO, startOfDay } from 'date-fns';
import type { CrmEventDTO } from '../../../server/dto/crm-event-dto.ts';
import type { CrmTaskDTO } from '../../../server/dto/crm-task-dto.ts';

export type UpcomingEntry = { type: 'event'; event: CrmEventDTO } | { type: 'task'; task: CrmTaskDTO };

export type UpcomingDay = {
    /** Missing for open tasks without a due date. */
    date?: Date;
    entries: UpcomingEntry[];
};

/** Upcoming events and open tasks by day, latest first like the past feed; undated tasks lead. */
export function groupUpcoming(events: CrmEventDTO[], tasks: CrmTaskDTO[]): UpcomingDay[] {
    const entries: { date?: Date; entry: UpcomingEntry }[] = [
        ...events.map((event) => ({
            date: startOfDay(parseISO(event.date)),
            entry: { type: 'event' as const, event },
        })),
        ...tasks.map((task) => ({
            date: task.dueDate ? startOfDay(task.dueDate) : undefined,
            entry: { type: 'task' as const, task },
        })),
    ];

    return Array.from(
        mapGroupBy(entries, ({ date }) => date?.getTime() ?? Number.POSITIVE_INFINITY),
        ([, group]) => ({ date: group[0]?.date, entries: group.map(({ entry }) => entry) }),
    ).toSorted(
        (a, b) =>
            (b.date?.getTime() ?? Number.POSITIVE_INFINITY) - (a.date?.getTime() ?? Number.POSITIVE_INFINITY),
    );
}
